import { render, staticRenderFns } from "./Offered.vue?vue&type=template&id=282ac380&scoped=true&"
import script from "./Offered.vue?vue&type=script&lang=js&"
export * from "./Offered.vue?vue&type=script&lang=js&"
import style0 from "./Offered.vue?vue&type=style&index=0&id=282ac380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ac380",
  null
  
)

export default component.exports